export enum TranslationsMx {
  YEAR_MONTH_DAY = '{year}-{month}-{day}',
  MON = 'Lunes',
  TUE = 'Martes',
  WED = 'Miercoles',
  THU = 'Jueves',
  FRI = 'Viernes',
  SAT = 'Sabado',
  SUN = 'Domingo',
  STREET_ADDRESS1 = 'Direccion 1',
  STREET_ADDRESS2 = 'Direccion 2',
  CITY = 'Ciudad',
  STATE = 'Estado',
  ZIP_CODE = 'Codigo postal',
  COUNTRY = 'Pais',
  OK = 'Ok',
  CANCEL = 'Cancelar',
  CONFIRMATION = 'Confirmacion',
  ARE_YOU_SURE_YOU_WANT_TO_CANCEL = 'Estas seguro de querer cancelar?',
  STEP = 'Paso',
  OF = 'de',
  PREVIOUS = 'Anterior',
  NEXT = 'Siguiente',
  SUBMIT = 'Enviar',
  CLOSE = 'Cerrar',
  ENLARGED_ATTACHMENT = 'Adjunto ampliado',
  NO_INFO = 'No hay informacion',
  BEDROOMS = 'Habitaciones',
  BATHROOMS = 'Baños',
  HOME = 'Casa',
  PROGRESS = 'Progreso',
  START_DATE = 'Fecha de inicio',
  END_DATE = 'Fecha de fin',
  UNKNOWN = 'Desconocido',
  VIEW_ALL = 'Ver todos',
  FEET = 'ft',
  SUCCESS = '¡Exito!',
  FINISH = 'Finalizar',
  SOMETHING_WENT_WRONG = '¡Ups! Algo salio mal!',
  EMAIL = 'Correo electronico',
  UPLOAD_FILE = 'Subir archivo',
  BACK = 'Atras',
  TENANT_SIGN_IN = 'Portal de inquilino',
  NO_RENTAL_HISTORY_ERROR = 'Por favor, ingrese detalles para al menos una renta previa.',
  REMOVE = 'Remover',
  APPLICANT_INFORMATION = 'Informacion del solicitante',
  POTENTIAL_UNITS = 'Unidades potenciales',
  UNITS_OF_INTEREST = 'Unidades de interes',
  ALL_UNITS = 'Todas las unidades',
  OPEN_TO_ALL_UNITS = 'Abierto a todas las unidades',
  RENTAL_HISTORY = 'Historial de renta',
  WORK_HISTORY = 'Historial de trabajo y verificacion de ingresos',
  TERM_AND_CONDITIONS = 'Terminos y condiciones',
  CONFIRM_YOUR_IDENTITY = 'Confirma tu identidad',
  PETS_AND_CARS = 'Mascotas y autos',
  QUESTIONS = 'Preguntas',
  RENTAL_APPLICATION = 'Solicitud de renta',
  SUBMIT_A_RENTAL_APPLICATION = 'Enviar una solicitud de renta',
  MAGICDOOR_TERMS = 'Terminos y condiciones de MagicDoor',
  TRANS_UNION_TERMS = 'Terminos y condiciones de TransUnion',
  ADD_RENTAL_HISTORY = 'Agregar historial de renta',
  REASON_FOR_LEAVING = 'Razon para dejar',
  LANDLORD_NAME = 'Nombre del propietario',
  LANDLORD_PHONE = 'Telefono del propietario',
  RENT = 'Renta',
  MOVE_IN_DATE = 'Fecha de entrada',
  MOVE_OUT_DATE = 'Fecha de salida',
  I_HAVE_READ_AND_AGREED_TO_THE_TERMS = 'He leido y aceptado los terminos de servicio',
  ADD_EMPLOYMENT = 'Agregar empleo',
  EMPLOYMENT_HISTORY = 'Historial de empleo',
  ANNUAL_INCOME = 'Ingreso anual',
  NAME = 'Nombre',
  PHONE = 'Telefono',
  POSITION = 'Posicion',
  JOB_TITLE = 'Titulo del trabajo',
  SALARY = 'Salario',
  START_SCREENING = 'Iniciar verificación',
  PAYMENT_DETAILS = 'Detalles de pago',
  SUBMIT_ANSWERS = 'Enviar respuestas',
  PAYMENT_PROCESSING = 'Procesando pago ...',
  PAYMENT_PROCESSING_BLURB = 'Tu transaccion esta siendo procesada. Esto puede tomar un par de minutos. Por favor, espera y no cierra la pantalla',
  DONE = 'Listo',
  RENTAL_APPLICATION_SUCCESSFULLY_SUBMITTED = '¡Tu solicitud de renta fue enviada con exito!',
  RENTAL_APPLICATION_NOTIFICATION = 'El estado de la solicitud sera notificado por correo electronico. Por favor, revisa tu correo electronico.',
  CONNECTING_TO_TRANS_UNION = 'Conectando a TransUnion para preparar el cuestionario y iniciar la verificacion de identidad ...',
  CONNECTING_TO_TRANS_UNION_BLURB = 'Por favor, espera y no salgas de esta pagina - estamos obteniendo tu cuestionario y configurando la verificacion de identidad.',
  CONTACT_CUSTOMER_SUPPORT = 'Para completar tu proceso de verificación, por favor contacta a nuestro soporte de cliente en ',
  CONTACT_CUSTOMER_SUPPORT_BLURB = 'Mientras estes en la llamada, por favor, permanece en esta pantalla para actualizaciones en tiempo real. Una vez que tu llamada termine, por favor, permanece en la pagina para el siguiente paso.',
  UNABLE_TO_VERIFY_IDENTITY = 'No podemos verificar tu identidad en linea.',
  RENTER_SCREENING_ID = 'ID de verificación de inquilino= {renterID}',
  PAGE_NOT_FOUND = 'Pagina no encontrada',
  PAGE_NOT_FOUND_BLURB_1 = 'Parece que encontraste la puerta al gran nada, lo sentimos por eso.',
  PAGE_NOT_FOUND_BLURB_2 = 'Por favor, visita nuestra pagina principal para llegar a donde necesitas ir.',
  COMPANY_NOT_FOUND = 'Parece que la pagina que estas buscando no existe. Por favor, revisa la URL o contacta a tu administrador de propiedades para obtener ayuda.',
  FIRST_NAME = 'Nombre',
  LAST_NAME = 'Apellido',
  SSN = 'SSN',
  DATE_OF_BIRTH = 'Fecha de nacimiento',
  VIEW_IN_FULL_SCREEN = 'Abrir en una nueva pestaña',
  WELCOME = 'Bienvenido',
  YOU_HAVE_TO_ACCEPT_THIS_LICENSE_AGREEMENT = 'Tienes que aceptar este acuerdo de licencia',
  PAY = 'Pagar',
  RENTAL_APPLICATION_FEE_BLURB = 'Se requiere pagar una tarifa no reembolsable de {amount} para enviar tu solicitud, que se destinara a los costos de verificación.',
  TEXT_ONLY = 'Solo texto',
  LEASING = 'Arrendamiento',
  CONFIRM = 'Confirmar',
  END_DATE_IS_INVALID = 'Fecha de fin no es valida',
  FIRST_NAME_IS_INVALID = 'Nombre no es valido',
  LAST_NAME_IS_INVALID = 'Apellido no es valido',
  EMAIL_IS_INVALID = 'Email no es valido',
  PHONE_NUMBER_IS_INVALID = 'Telefono no es valido',
  DATE_OF_BIRTH_IS_INVALID = 'Fecha de nacimiento no es valida',
  DATE_OF_BIRTH_IS_GREATER = 'La edad no puede ser mayor a 125 años',
  DATE_OF_BIRTH_IS_LESSER = 'La edad no puede ser menor a 18 años',
  ANNUAL_INCOME_IS_INVALID = 'Ingreso anual no es valido',
  SSN_IS_INVALID = 'SSN no es valido',
  EMPLOYER_NAME_IS_INVALID = 'Nombre del empleador no es valido',
  SALARY_IS_INVALID = 'Salario no es valido',
  POSITION_TITLE_IS_INVALID = 'Position/title is not valid',
  START_DATE_IS_INVALID = 'Fecha de inicio no es valido',
  END_DATE_IS_INVALID_EARLIER = 'La fecha de fin no puede ser anterior a la fecha de inicio',
  ADDRESS_IS_INVALID = 'Direccion no es valido',
  STREET_ADDRESS_1_IS_INVALID = 'Direccion 1 no es valido',
  STREET_ADDRESS_2_IS_INVALID = 'Direccion 2 no es valido',
  REASON_FOR_LEAVING_IS_INVALID = 'La longitud de la razon para dejar no puede exceder 500',
  CITY_IS_INVALID = 'Ciudad no es valido',
  STATE_IS_INVALID = 'Estado no es valido',
  ZIP_CODE_IS_REQUIRED = 'Codigo postal es requerido',
  ZIP_CODE_IS_INVALID = 'El codigo postal de los EE.UU. debe consistir en 5 digitos',
  COUNTRY_IS_INVALID = 'Pais no es valido',
  LANDLORD_NAME_IS_INVALID = 'Nombre del propietario no es valido',
  LANDLORD_PHONE_NUMBER_IS_INVALID = 'Telefono del propietario no es valido',
  RENT_IS_INVALID = 'Renta no es valido',
  MOVE_IN_DATE_IS_INVALID = 'Fecha de entrada no es valido',
  MOVE_OUT_DATE_IS_INVALID = 'Fecha de salida no es valido',
  MOVE_IN_DATE_IS_LATER = 'La fecha de entrada no puede ser posterior a la fecha de salida',
  MOVE_OUT_DATE_IS_EARLIER = 'La fecha de salida no puede ser anterior a la fecha de entrada',
  JOB_TITLE_IS_INVALID = 'Titulo del trabajo no es valido',
  FILE_IS_REQUIRED = 'Archivo es requerido',
  COMPANY_NAME = 'Nombre de la empresa',
  FOLLOW_US = 'Siguenos',
  PROPERTIES = 'Propiedades',
  CONTACT_US = 'Contactanos',
  LET_US_GUIDE_YOUR_HOME = 'Permitenos guiarte a tu hogar',
  BANNER_TITLE = 'Descubre un lugar que te encantara vivir',
  SEARCH = 'Buscar',
  PROPERTY_FOR_YOU_TITLE = 'Propiedad para ti',
  PROPERTY_FOR_YOU_SUBTITLE = 'Busca y guarda un par de casas que te gusten y te daremos recomendaciones.',
  PINNED = 'Fijado',
  PRICE = 'Precio',
  MIN = 'Minimo',
  MAX = 'Maximo',
  NO_MIN = 'no minimo',
  NO_MAX = 'no maximo',
  HOME_TYPE = 'Tipo de casa',
  BEDS_AND_BATHS = 'Habitaciones y baños',
  ANY = 'Cualquier',
  SINGLE_FAMILY = 'Familia unica',
  MULTI_FAMILY = 'Familia multiple',
  COMMERCIAL = 'Comercial',
  CONDO = 'Condominio',
  TOWN_HOUSE = 'Casa de vecindario',
  RESET = 'Reiniciar',
  CONTACT_MANAGER = 'Contactar al administrador',
  PET = 'Mascota',
  PETS = 'Mascotas',
  AC = 'Aire acondicionado',
  PARKING = 'Estacionamiento',
  UTILITIES_INCLUDED = 'Utilidades incluidas',
  INTERIOR_AMENITIES = 'Amenidades interiores',
  OUTDOOR_AMENITIES = 'Amenidades al aire libre',
  COMMUNITY_AMENITIES = 'Amenidades comunales',
  OUTDOOR = 'Al aire libre',
  LISTED = 'Listado',
  MONTH = 'Mes',
  SQFT = 'sqft',
  OVERVIEW = 'Resumen',
  HOME_HIGHLIGHTS = 'Destacados de la casa',
  FACTS_AND_FEATURES = 'Facts y caracteristicas',
  LOCAL_INFORMATION = 'Informacion local',
  SELECT_PRICE = 'Seleccionar precio',
  SELECT_HOME_TYPE = 'Seleccionar tipo de casa',
  SELECT_MOVE_IN_DATE = 'Seleccionar fecha de entrada',
  SLIDE_UP_TO_LOAD_MORE = 'Desliza hacia arriba para cargar mas',
  APPLY = 'Aplicar',
  PROPERTY_DETAIL = 'Detalle de la propiedad',
  ZERO_RESULTS_DESC = 'No se encontraron resultados para la direccion proporcionada. Por favor, revisa la direccion y vuelve a intentarlo.',
  MAP_ERROR_DESC = 'Ocurrio un error al cargar el mapa. Por favor, intenta nuevamente mas tarde.',
  SEARCH_FOR_YOUR_DREAM_HOME = 'Busca tu casa soñada',
  ALL_RIGHTS_RESERVED = 'Todos los derechos reservados',
  WE_CURRENTLY_DO_NOT_HAVE_ANY_AVAILABLE_UNITS = 'Actualmente no tenemos unidades disponibles, pero siempre puedes enviar una solicitud de renta a nosotros',
  PRIVACY_POLICY = 'Politica de privacidad',
  TERMS_OF_SERVICE = 'Terminos de servicio',
  EQUAL_HOUSING_OPPORTUNITY = 'Igualdad de oportunidades',
  FILTER = 'Filtrar',
  FILTERS = 'Filtros',
  SIGN_HERE = 'Firmar aqui!',
  ALLOWED = 'Permitido',
  MONTHLY_PET_FEES = 'Tarifa mensual de mascotas',
  NO_LIMIT = 'Sin limite',
  PET_DEPOSIT = 'Deposito de mascota',
  SMALL_WEIGHT = 'Pequeño (menos de 22.0462 libras)',
  MEDIUM_WEIGHT = 'Mediano (22.0462 - 55.1156 libras)',
  LARGE_WEIGHT = 'Grande (55.1156 - 110.2311 libras)',
  CATS = 'Gatos',
  DOGS = 'Perros',
  OTHER = 'Otro',
  FISH = 'Peces',
  BIRDS = 'Pajaros',
  REPTILES = 'Reptiles',
  OTHERS = 'Otros',
  ALL_ALLOWED = 'Todos permitidos',
  DESIRED_MOVE_IN_DATE_IS_INVALID = 'Fecha de entrada deseada no es valida',
  DESIRED_MOVE_IN_DATE = 'Fecha de entrada deseada',
  CURRENT_UNIT_IS_UNLISTED = 'La unidad a la que estas aplicando no esta listada y se retornara a la pagina principal en 3 segundos.',
  PLEASE_ANSWER_THIS_QUESTION = 'Por favor, responde esta pregunta',
  COMMENT_CANNOT_EXCEED = 'El comentario no puede exceder 500 caracteres',
  YOU_CAN_ADD_A_COMMENT_TO_THE_MANAGER = 'Puedes agregar un comentario al administrador',
  COMMENT = 'Comentario',
  PET_NAME_IS_INVALID = 'Nombre de la mascota no es valido',
  BREED_IS_INVALID = 'Raza no es valido',
  PET_WEIGHT_IS_INVALID = 'Peso de la mascota no es valido',
  AGE_IS_INVALID = 'Edad no es valida',
  GENDER_IS_INVALID = 'Genero no es valido',
  SPAY_NEUTER_STATUS_IS_INVALID = 'Estado de esterilizacion no es valido',
  SERVICE_ANIMAL_STATUS_IS_INVALID = 'Estado de animal de servicio no es valido',
  EMOTIONAL_SUPPORT_ANIMAL_STATUS_IS_INVALID = 'Estado de animal de soporte emocional no es valido',
  CAR_MAKE_IS_INVALID = 'Marca del coche no es valido',
  MODEL_IS_INVALID = 'Modelo no es valido',
  YEAR_IS_INVALID = 'Año no es valido',
  LICENSE_PLATE_IS_INVALID = 'Placa de licencia no es valido',
  STATE_REGISTRATION_IS_INVALID = 'Registro de estado no es valido',
  CAR_COLOR_IS_INVALID = 'Color del coche no es valido',
  YOU_HAVE_SUCCESSFULLY_SIGNED_THE_LEASE = 'Has firmado el contrato con exito. Manten un ojo en las futuras notificaciones de nosotros.',
  BREED = 'Raza',
  WEIGHT = 'Peso',
  AGE = 'Edad',
  GENDER = 'Genero',
  CAR = 'Coche',
  CAR_MAKE = 'Marca del coche',
  MODEL = 'Modelo',
  YEAR = 'Año',
  LICENSE_PLATE = 'Placa de licencia',
  STATE_REGISTRATION = 'Registro de estado',
  COLOR = 'Color',
  SPAYED_OR_NEUTERED = 'Mi mascota esta esterilizada/desterilizada',
  SERVICE_ANIMAL = 'Mi mascota es un animal de servicio',
  EMOTIONAL_SUPPORT_ANIMAL = 'Mi mascota es un animal de soporte emocional',
  MM_DD_YYYY = 'MM/DD/YYYY',
  OPERATION_FAILED_PLEASE_TRY_AGAIN_LATER = 'Operación fallida, por favor intenta nuevamente mas tarde',
  REMOVE_SELECTED = 'Remover seleccionado',
  PURCHASE_RENTAL_INSURANCE = 'Comprar seguro de renta',
  LINK_EXPIRED = 'Link expirado',
  THE_LINK_HAS_EXPIRED_BUT_WE_VE_SENT_YOU_ANOTHER_ONE_TO_YOUR_REGISTERED_EMAIL_ADDRESS = 'El link ha expirado, pero te hemos enviado otro a tu correo electronico registrado.',
  DO_YOU_HAVE_A_PET = '¿Tienes una mascota?',
  ADD_NEW_PET = 'Agregar una nueva mascota',
  DO_YOU_HAVE_A_CAR = '¿Tienes un coche?',
  ADD_NEW_CAR = 'Agregar un nuevo coche',
  NO_UNITS_LISTED = 'Actualmente, no hay unidades listadas',
  OR_LESS = 'o menos',
  OR_MORE = 'o mas',
  ANY_PRICE = 'Cualquier precio',
  NO_MORE_RESULTS = 'No hay mas resultados',
  BY_SUBMITTING_THIS_APPLICATION_BLURB = 'Al enviar este formulario, aceptas dar consentimiento a {companyName} para recibir notificaciones de cuenta y mensajes de comunicaciones directas de la empresa, al numero proporcionado, incluyendo mensajes enviados por autodialer. La frecuencia de los mensajes puede variar. El consentimiento no es una condicion de compra. Los costos de mensajes y datos pueden aplicarse. Desuscribete en cualquier momento respondiendo STOP. Responde a HELP para obtener ayuda. ',
  SEARCH_UNITS = 'Buscar unidades...',
}
